export default __webpack_public_path__ + "static/media/photoshop.6576d308.svg";